import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

class AddTipsState extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/orders/${urlId}/tip`, ...params);
  }
}

class TippingState {
  @lazyInitialize @nonenumerable tipTherapist = new AddTipsState(this.ctx);

  @nonenumerable listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default TippingState;



// WEBPACK FOOTER //
// ./spa/state/tipping.jsx